import React from 'react'
import Button from '@Components/Buttons/Button'

interface ShareUpdateRequestActionsProps {
    disabled: boolean
    onBack: () => void
    onSubmit: () => void
}

const ShareUpdateRequestActions = ({ disabled, onBack, onSubmit }: ShareUpdateRequestActionsProps) => (
    <div className="share-update-request-actions">
        <Button mainColor type="secondary" onClick={onBack}>
            Back
        </Button>
        <Button mainColor type="primary" disabled={disabled} onClick={onSubmit}>
            Submit Request
        </Button>
    </div>
)

export default ShareUpdateRequestActions
